import { AxiosResponse } from 'axios';
import api from '../api';
import { ChangePasswordRequest, ChangePasswordResponse } from '../../interface/changePasswordModel';

const changePassword = async (
  data: ChangePasswordRequest,
): Promise<AxiosResponse<ChangePasswordResponse>> => {
  // eslint-disable-next-line no-useless-catch
  try {
    const res: AxiosResponse<ChangePasswordResponse> = await api.put('/user/changePassword', data);
    return res;
  } catch (error: any) {
    // Throw the original error object so frontend can access error.response.data.message
    throw error;
  }
};

/**
 * Persist the user's selected UI language to the backend so that
 * backend-generated emails and PDFs render in the same language.
 * Best-effort: callers should not block the UI on this.
 */
const setPreferredLanguage = async (language: string): Promise<void> => {
  await api.patch('/user/language', { language });
};

export const userService = {
  changePassword,
  setPreferredLanguage,
};
